import { Client } from "@/Common/Api/Client";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { DiagnosisResponse } from "@/Patient/Api/MedfarBilling/Dto/Responses/DiagnosisResponse";

interface IMedfarBillingAutoCompleteProps {
    serverOperation: ServerOperations.Server;
    onItemSelectCallback: (item: DiagnosisResponse) => void;
    style?: React.CSSProperties;

}
class MedfarBillingAutoCompleteState {
    public text: string;
    public list: Immutable.List<DiagnosisResponse>;
}

class MedfarBillingAutoComplete extends BaseReactComponent<IMedfarBillingAutoCompleteProps, MedfarBillingAutoCompleteState> {
    private timeoutReference: number = -1;
    private blurReference: number = -1;

    constructor(props: IMedfarBillingAutoCompleteProps) {
        super(props);

        const initialState = new MedfarBillingAutoCompleteState();
        initialState.text = "";
        initialState.list = Immutable.List([]);
        this.state = initialState;
    }

    public render(): JSX.Element {
        let style: React.CSSProperties = this.props.style;
        if (this.props.style == null)
            style = { width: "290px" };

        return (
            <div className="fmp-autocomplete" style={style}>
                <input type="text" onChange={(e: any) => this.onTextChange(e.target.value)} onBlur={() => this.onBlur()} value={this.state.text} className="form-control" />
                <div className="list-container-fmp">
                    {this.state.list.size > 0 && (
                        <div className="results-container">
                            <ul className="results-list" style={{ width: "690px" }}>
                                {this.state.list.map(item =>
                                    <li key={item.CodeCIM}><a onClick={() => this.selectItem(item)} onMouseDown={() => this.selectItem(item)}>{item.DescriptionLongue} ({item.CodeCIM}) </a></li>
                                )}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    private onTextChange(val: string): void {
        this.mutateState(s => s.text = val);

        clearTimeout(this.timeoutReference);
        this.timeoutReference = window.setTimeout(() => this.loadData(), 400);
    }

    private loadData(): void {
        if (this.state.text.trim().length < 2)
            return;

        const client = new Client();

        client.Post(
            this.props.serverOperation,
            { SearchText: this.state.text },
            response => {
                const model: DiagnosisResponse[] = response.DiagnosisList;
                this.mutateState(s => s.list = Immutable.List(model));
            },
            error => {
                console.error(error);
            }
        );
    }

    public selectItem(item: DiagnosisResponse): void {
        clearTimeout(this.blurReference);

        this.props.onItemSelectCallback(item);

        this.mutateState(s => {
            s.text = "";
            s.list = Immutable.List([]);
        });
    }

    private onBlur(): void {
        this.blurReference = window.setTimeout(() => this.mutateState(s => s.list = Immutable.List([])), 150);
    }
}

export { MedfarBillingAutoComplete };
